<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="日期">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="doctorName" label="医生"></el-table-column>
                <el-table-column sortable prop="sknCount" label="皮肤人数"></el-table-column>
                <el-table-column sortable prop="sknProject" label="皮肤项目数"></el-table-column>
                <el-table-column sortable prop="sknAmt" label="皮肤业绩"></el-table-column>
                <el-table-column sortable prop="registerCount" label="注射人数"></el-table-column>
                <el-table-column sortable prop="registerProject" label="注射项目数"></el-table-column>
                <el-table-column sortable prop="registerAmt" label="注射业绩"></el-table-column>
                <el-table-column sortable prop="countSum" label="总人数"></el-table-column>
                <el-table-column sortable prop="projectSum" label="总项目数"></el-table-column>
                <el-table-column sortable prop="amtSum" label="总业绩"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
    </div>
</template>
  <script>
export default {
    name: 'doctorTable',
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: [_g.getMonths()[0], _g.getMonths()[1]],
                endTime: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            formData: {
                floorNameList: [
                    {
                        floorName: '',
                        departmentCode: '',
                    }
                ]
            },
            tableHeight: "",
            isId: '',
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 380
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        // 查询数据列表
        query(page) {
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/register/findDoctorPerformanceList', querys, (res) => {
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
    },


}
</script>
  <style scoped>
@import "../../assets/css/main.css";
</style>